// export const COLOR_PRIMARY = "#4DB6AC"
// export const SIDEBAR_COLOR = "#4DB6AC"

// export const COLOR_PRIMARY = "#5C6BC0";
// export const SIDEBAR_COLOR = "#5C6BC0";

// export const COLOR_PRIMARY = "#009688";
// export const SIDEBAR_COLOR = "#009688";

export const COLOR_PRIMARY = "#405FF2";
export const SIDEBAR_COLOR = "#FFFFFF";

////ROles

export const SUPER_ADMIN_ROLE_ID = 1;
export const COMPANY_ADMIN_ROLE_ID = 2;
export const COMPANY_ADMIN_REPORT_ROLE_ID = [8, 10];

// Super Admin role
export const SUPER_ADMIN_ROLE_ACCESS = [1];
export const COMPANY_ADMIN_ROLE_ACCESS = [1, 2, 10, 8];

export const DASHBOARD_PERMISSION = 'ANDON_SYSTEM';
export const BREAKDOWN_PERMISSION = 'BREAKDOWN';
export const PNL_PERMISSION = 'PNL';
export const NOTIFICATION_PERMISSION = 'ALERT_SYSTEM'